import { Component } from '@angular/core';

import Chart from 'chart.js';
const ChartDataLabels = require('chartjs-plugin-datalabels');

// Workaround: TypeScript weet anders niet wat ChartDataLabels is
Chart.plugins.register(ChartDataLabels as any);
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
}
